<template>
  <div v-if="result" id="contents" class="order contents">
    <div class="orderComplete">
      <h2>
        {{
          isEventProduct ? '응모가 완료되었습니다.' : '구매가 완료되었습니다.'
        }}
        <span>{{ result.desc }}</span>
      </h2>
      <div>
        <dl>
          <dt>총 상품 금액</dt>
          <dd>{{ result.displayPrice.addComma() }}{{ result.currencyUnit }}</dd>
        </dl>
        <dl>
          <dt>할인금액</dt>
          <dd>-{{ befefit.addComma() }}{{ result.currencyUnit }}</dd>
        </dl>
        <dl>
          <dt>총 결제 금액</dt>
          <dd>{{ result.totalPrice.addComma() }}{{ result.currencyUnit }}</dd>
        </dl>
      </div>
    </div>
    <div class="orderPayInfo">
      <h2>결제 정보</h2>
      <div>
        <dl>
          <dt>{{ result.paymentTypeName }}</dt>
          <dd>
            {{ result.totalPrice.addComma() }}{{ result.currencyUnit }}
            <span class="date">({{ currentDate }})</span>
          </dd>
        </dl>
        <p v-if="result.paymentType === 2">
          ※ 현금영수증 발행정보는 구매내역 참고
        </p>
      </div>
    </div>
    <div class="orderBtSec">
      <button type="button" class="button53" @click="handleClick('/main')">
        쇼핑 계속하기
      </button>
      <button
        v-if="isShippingProduct || isEventProduct"
        type="button"
        class="button52"
        @click="$router.replace(`/purchaseView/${result.purchaseId}`)"
      >
        주문상세보기
      </button>
      <button
        v-else
        type="button"
        class="button52"
        @click="handleClick('/coupon')"
      >
        내 쿠폰함 가기
      </button>
    </div>
  </div>
</template>

<script>
import { beforeSendLog } from '@/utils'
import PaymentAPI from '@/api/payment'

export default {
  name: 'OrderComplete',
  props: {
    token: {
      type: String,
      default: ''
    },
    isShippingProduct: {
      type: Boolean,
      default: false
    },
    isEventProduct: {
      type: Boolean,
      default: false
    },
    productType: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      result: null,
      paymentType: {
        1: '카카오페이',
        2: '토스페이',
        3: 'PAYCO',
        4: '문화상품권',
        5: '신용카드'
      }
    }
  },
  computed: {
    befefit() {
      const { totalPrice, displayPrice } = this.result
      return displayPrice - totalPrice
    },
    currentDate() {
      if (this.result.currentDate) {
        const date = new Date()
        return `${date.getFullYear()}년 ${date.getMonth() +
          1}월 ${date.getDate()}일`
      } else {
        return ''
      }
    }
  },
  methods: {
    handleClick(path) {
      if (path === '/main') {
        beforeSendLog(
          'Continue',
          this.isShippingProduct ? { ProductType: this.productType } : undefined
        )
      } else if (path === '/coupon') {
        beforeSendLog('MyCoupon')
      } else {
        // purchaseView/${result.purchaseId}
        beforeSendLog('Detail')
      }

      this.$router.replace(path)
    }
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    const { result, token } = to.params
    if (result) {
      next(vm => vm.$set(vm, 'result', result))
    } else {
      PaymentAPI.getPaymentResult(token, responseData => {
        if (responseData.code === 0) {
          next(vm => vm.$set(vm, 'result', responseData.data))
        } else {
          next(vm => {
            const { name } = from
            vm.$router.replace(
              name === 'order' || !name ? { name: 'main' } : { name }
            )
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.order {
  .orderComplete {
    // padding: 0 16px;
    background-color: #fff;
    border-bottom: 1px solid #d6d6db;
    h2 {
      height: 146px;
      padding-top: 54px;
      font-weight: bold;
      font-size: 17px;
      text-align: center;
      span {
        display: block;
        padding-top: 11px;
        font-weight: normal;
        font-size: 14px;
      }
    }
  }
  .orderPayInfo {
    dl {
      position: relative;
      padding: 13px 16px 11px 80px;
      text-align: right;
    }
    dt {
      position: absolute;
      top: 18px;
      left: 14px;
      width: auto;
      font-size: 14px;
    }
    dd {
      width: auto;
      display: inline-block;
      text-align: left;
      font-size: 14px;
      line-height: 24px;
      color: #151721;
      font-weight: bold;
      .date {
        font-size: 12px;
        color: #636376;
      }
      span {
        font-weight: normal;
      }
    }
    p {
      padding: 0 14px 16px;
      font-size: 11px;
      color: #636376;
    }
  }
}
</style>
